var _circle, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#99B2C4"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 36,
    height: 36,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#99B2C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003E6B",
    d: "M16.709 17.201H8.492A.492.492 0 0 1 8 16.71V8.492C8 8.22 8.22 8 8.492 8h1.969c.272 0 .492.22.492.492v3.204a10.145 10.145 0 0 1 7.636-3.368 10.148 10.148 0 0 1 10.097 10.194c-.012 5.608-4.562 10.15-10.172 10.15-2.629 0-5.025-.997-6.83-2.634a.493.493 0 0 1-.019-.714l1.393-1.394a.491.491 0 0 1 .673-.021 7.191 7.191 0 0 0 4.783 1.81 7.215 7.215 0 0 0 7.218-7.219 7.215 7.215 0 0 0-7.218-7.219 7.206 7.206 0 0 0-5.836 2.967h4.031c.272 0 .492.22.492.492v1.969c0 .272-.22.492-.492.492z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIconActive);
export default __webpack_public_path__ + "static/media/undo-icon-active.16128f767f1b8f3fd6cccbedc2cf9a88.svg";
export { ForwardRef as ReactComponent };